/**
 * Production-safe logging utility for admin panel
 * Logs are only visible in development mode
 * Reduces console spam and prevents data leaks in production
 */

const isDev = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development';

export const logger = {
  /**
   * Log info messages (🔵 prefix)
   */
  info: (message: string, data?: any) => {
    if (isDev) {
      console.log(`🔵 ${message}`, data);
    }
  },

  /**
   * Log success messages (✅ prefix)
   */
  success: (message: string, data?: any) => {
    if (isDev) {
      console.log(`✅ ${message}`, data);
    }
  },

  /**
   * Log warning messages (⚠️ prefix)
   */
  warn: (message: string, data?: any) => {
    if (isDev) {
      console.warn(`⚠️ ${message}`, data);
    }
  },

  /**
   * Log error messages (❌ prefix)
   */
  error: (message: string, error?: any) => {
    if (isDev) {
      console.error(`❌ ${message}`, error);
    }
  },

  /**
   * Always log errors (even in production - for debugging)
   */
  criticalError: (message: string, error: any) => {
    console.error(`🚨 CRITICAL: ${message}`, error);
  },

  /**
   * Debug logs with detailed data
   */
  debug: (message: string, data?: any) => {
    if (isDev) {
      console.log(`🐛 DEBUG: ${message}`, data);
    }
  },
};

export default logger;
